import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button, Table, Form, Input, InputNumber, Modal, message } from "antd";
import RenderTxt from "@components/renderTxt";
import SystemApi from "@api/sys";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import SearchForm from "@components/SearchForm";
import moment from "moment";

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};
const StoreManage = ({ userInfo }) => {
  let stationId = "-1";
  if (userInfo.stationIds) {
    userInfo.stationIds.includes(",")
      ? (stationId = userInfo.stationIds.split(",")[0])
      : (stationId = userInfo.stationIds);
  }
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [editId, setEditId] = useState();
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
    stationId,
  });
  const [tableSource, setTableSource] = useState({});
  const [inputList] = useState([
    {
      label: "仓库名称:",
      name: "name",
      message: "请输入仓库名称",
      span: 8,
      labelCol: 6,
    },
  ]);

  const columns = [
    {
      title: "仓库名称",
      dataIndex: "name",
      align: "center",
      key: "name",
    },
    {
      title: "备注",
      dataIndex: "remark",
      align: "center",
      key: "remark",
      render: (text) => RenderTxt(text),
    },
    {
      title: "创建时间",
      dataIndex: "createAt",
      align: "center",
      key: "createAt",
      render: (text) => moment(text).format("YYYY-MM-DD HH:mm:ss"),
    },
    {
      title: "操作",
      dataIndex: "action",
      align: "center",
      key: "action",
      render: (text, obj) => {
        return (
          <>
            <Button type="primary" onClick={() => editRecord(obj)}>
              编辑
            </Button>
            <Button
              style={{ marginLeft: 8 }}
              type="primary"
              onClick={() => delRecord(obj.id)}
              danger
            >
              删除
            </Button>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    getListPages();
  }, [searchParams]);

  const getListPages = () => {
    setLoading(true);
    SystemApi.storeList(searchParams).then((res) => {
      setLoading(false);
      if (res.status !== "0") return;
      const { data } = res.data;
      data.map((item) => {
        item.key = item.id;
      });
      setTableSource(res.data);
    });
  };

  const delRecord = (id) => {
    Modal.confirm({
      onOk: () => {
        SystemApi.storeRemove({ id }).then((res) => {
          if (res.status !== "0") return;
          message.success("删除成功");
          if (tableSource.data.length == 1 && tableSource.pageNum > 1) {
            searchParams({
              ...searchParams,
              pageNum: searchParams.pageNum - 1,
            });
          } else {
            getListPages();
          }
        });
      },
      title: "请确认",
      icon: <ExclamationCircleOutlined />,
      content: "是否删除",
      okText: "确认",
      cancelText: "取消",
    });
  };

  const editRecord = (obj) => {
    setVisible(true);
    setEditId(obj.id);
    form.setFieldsValue({ ...obj });
  };

  const cancel = () => {
    setVisible(false);
    form.resetFields();
    setEditId(null);
  };

  const save = () => {
    form.validateFields().then((values) => {
      const params = { ...values, stationId };
      if (editId) {
        setConfirmLoading(true);
        SystemApi.storeUpdate({ ...params, id: editId }).then((res) => {
          setConfirmLoading(false);
          if (res.status !== "0") return;
          message.success("修改成功");
          cancel();
          getListPages();
        });
      } else {
        setConfirmLoading(true);
        SystemApi.storeSave(params).then((res) => {
          setConfirmLoading(false);
          if (res.status !== "0") return;
          message.success("新增成功");
          cancel();
          getListPages();
        });
      }
    });
  };

  const handleTableChange = (pagination) => {
    const params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    };
    setSearchParams(params);
  };

  const search = (values) => {
    setSearchParams({
      ...searchParams,
      ...values,
      pageNum: 1,
      pageSize: 10,
    });
  };

  return (
    <div style={{ padding: 20 }}>
      <SearchForm span={6} inputList={inputList} onSearch={search} />
      <Button
        type="primary"
        style={{ marginBottom: "10px" }}
        onClick={() => setVisible(true)}
      >
        新增
      </Button>
      <Table
        loading={loading}
        columns={columns}
        dataSource={tableSource.data}
        pagination={{
          current: tableSource.pageNum,
          pageSize: tableSource.pageSize,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal: (total) => `共${total}条数据`,
          total: tableSource.total * 1,
        }}
        onChange={handleTableChange}
      />
      {visible && (
        <Modal
          title={editId ? "编辑" : "新增"}
          open={visible}
          onCancel={cancel}
          onOk={save}
          confirmLoading={confirmLoading}
        >
          <Form {...layout} form={form}>
            <Form.Item
              label="仓库名称"
              name="name"
              rules={[{ required: true, message: "请输入仓库名称!" }]}
            >
              <Input placeholder="请输入仓库名称" />
            </Form.Item>
            <Form.Item
              label="备注"
              name="remark"
              rules={[{ required: false, message: "请输入备注!" }]}
            >
              <Input placeholder="请输入备注" />
            </Form.Item>
          </Form>
        </Modal>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(StoreManage);
